/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/images/pokedex/react-structure.png",
        "alt": "Estructura de archivos de React"
      }}></img></p>
    <p>{`El CLI nos genera los archivos básicos para iniciar una app como `}<inlineCode parentName="p">{`App.js`}</inlineCode>{` o `}<inlineCode parentName="p">{`index.js`}</inlineCode>{`, además de ciertos archivos para configurar el Unit Testing.`}</p>
    <p>{`También genera una carpeta public donde tenemos los iconos, el manifest y el HTML base de nuestra aplicación.`}</p>
    <p>{`El resto de nuestro código, nuestros estilos y nuestras imágenes lo colocaremos en sus respectivas carpetas dentro de src.`}</p>
    <p>{`Un detalle es que a simple vista no tenemos ningún archivo para modificar la configuración de nuestro linter, webpack o babel.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;